import React from 'react';
import { Box, Button, Typography } from '@mui/material';

const gradientMapping = {
  blue: 'linear-gradient(hsl(223, 90%, 50%), hsl(208, 90%, 50%))',
  purple: 'linear-gradient(hsl(283, 90%, 50%), hsl(268, 90%, 50%))',
  red: 'linear-gradient(hsl(3, 90%, 50%), hsl(348, 90%, 50%))',
  indigo: 'linear-gradient(hsl(253, 90%, 50%), hsl(238, 90%, 50%))',
  orange: 'linear-gradient(hsl(43, 90%, 50%), hsl(28, 90%, 50%))',
  green: 'linear-gradient(hsl(123, 90%, 40%), hsl(108, 90%, 40%))',
};

const GlassIcons = ({ items, className }) => {
  const getBackgroundStyle = (color) =>
    gradientMapping[color]
      ? { background: gradientMapping[color] }
      : { background: color };

  return (
    <Box
 sx={{marginTop:'10px',marginRight:'10px'}}
  className={className}
>

      {items.map((item, index) => (
        <Button
          key={index}
          disableRipple
          aria-label={item.label}
          sx={{
            position: 'relative',
            backgroundColor: 'transparent',
            width: '3em',
            height: '3em',
            perspective: '20em',
            transformStyle: 'preserve-3d',
            WebkitTapHighlightColor: 'transparent',
            p: 0,
            minWidth: 0,
            '&:hover .back-layer': {
              transform: 'rotate(20deg) translate3d(-0.3em, -0.3em, 0.3em)',
            },
            '&:hover .front-layer': {
              transform: 'translateZ(1em)',
            },
            '&:hover .label': {
              opacity: 1,
              transform: 'translateY(15%)',
            },
          }}
        >
          {/* Back Layer */}
          <Box
            className="back-layer"
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              borderRadius: '0.75em',
              transition: 'opacity 300ms, transform 300ms cubic-bezier(0.83, 0, 0.17, 1)',
              transformOrigin: '100% 100%',
              transform: 'rotate(12deg)',
              ...getBackgroundStyle(item.color),
              boxShadow: '0.3em -0.3em 0.5em hsla(223, 10%, 10%, 0.15)',
            }}
          />

          {/* Front Layer */}
          <Box
            className="front-layer"
            sx={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              borderRadius: '0.75em',
              background: 'hsla(0, 0%, 100%, 0.15)',
              transition: 'opacity 300ms, transform 300ms cubic-bezier(0.83, 0, 0.17, 1)',
              transformOrigin: '80% 50%',
              display: 'flex',
              backdropFilter: 'blur(0.6em)',
              WebkitBackdropFilter: 'blur(0.6em)',
              boxShadow: '0 0 0 0.05em hsla(0, 0%, 100%, 0.3) inset',
            }}
          >
            <Box
              sx={{
                m: 'auto',
                width: '1em',
                height: '1em',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
              aria-hidden="true"
            >
              {item.icon}
            </Box>
          </Box>

          {/* Label
          <Typography
            className="label"
            sx={{
              position: 'absolute',
              top: '100%',
              left: 0,
              right: 0,
              textAlign: 'center',
              whiteSpace: 'nowrap',
              lineHeight: 1.6,
              fontSize: '0.75rem',
              opacity: 0,
              transition: 'opacity 300ms, transform 300ms cubic-bezier(0.83, 0, 0.17, 1)',
              transform: 'translateY(0)',
               mt: '0.2em',
            }}
          >
            {item.label}
          </Typography> */}
        </Button>
      ))}
    </Box>
  );
};

export default GlassIcons;
